import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { IAssignmentType } from '../models/assignment-type';
import { AssignmentTypeService } from '../services/assignment-type.service';

@Component({
    selector: 'app-assignment-type',
    templateUrl: './assignment-type.component.html',
    styleUrls: ['./assignment-type.component.css'],
    standalone: false
})
export class AssignmentTypeComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private assignmentTypeService: AssignmentTypeService,
    private appNotificationService: AppNotificationService
  ) { }

  assignmentTypes: IAssignmentType[] = [];
  public formGroup!: UntypedFormGroup;
  private editedRowIndex!: number;

  ngOnInit(): void {
    this.assignmentTypes = this.route.snapshot.data.assignmentTypes as IAssignmentType[];
  }

  updateList() {
    this.assignmentTypeService.searchAssignmentTypes({ pageNumber: 0, pageSize: 999999 })
      .pipe(first())
      .subscribe(response => {
        this.assignmentTypes = response.data;
      });
  }

  addHandler({ sender }) {
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(null, Validators.required),
      isActive: new UntypedFormControl(true),
      sortOrder: new UntypedFormControl(0),
    });

    sender.addRow(this.formGroup);
  }

  editHandler({ sender, rowIndex, dataItem }) {
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      name: new UntypedFormControl(dataItem.name, Validators.required),
      isActive: new UntypedFormControl(dataItem.isActive),
      sortOrder: new UntypedFormControl(dataItem.sortOrder),
    });

    this.editedRowIndex = rowIndex;

    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public saveHandler(event) {
    const request: any = {
      name: event.formGroup.value.name,
      isActive: event.formGroup.value.isActive,
      sortOrder: event.formGroup.value.sortOrder,
      id: event.dataItem.id ?? null,
    };
    if (!event.dataItem.id) {
      this.assignmentTypeService.createAssignmentType(request)
        .subscribe(() => this.updateList());
    } else {
      this.assignmentTypeService.updateAssignmentType(request)
        .subscribe(() => this.updateList());
    }

    event.sender.closeRow(event.rowIndex);
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }

  deletionDialogOpened = false;
  private itemToDelete: { id: string } | null = null;

  public removeHandler({ dataItem }) {
    this.itemToDelete = dataItem;
    this.deletionDialogOpened = true;
  }

  public deleteConfirmed() {
    const dataItem = this.itemToDelete;
    this.itemToDelete = null;
    if (!dataItem) return;
    this.assignmentTypeService.deleteAssignmentType(dataItem.id)
      .subscribe({
        next: () => this.updateList(),
        error: (err: HttpErrorResponse) => {
          if (err.status === 409) {
            this.appNotificationService.notification$.next({
              message: 'Diese Auftragsart wird bereits in Aufträgen verwendet. Deaktivieren Sie sie stattdessen.',
              style: 'error'
            });
          } else {
            this.appNotificationService.notification$.next({
              message: 'Fehler beim Löschen der Auftragsart.',
              style: 'error'
            });
          }
        }
      });
  }
}
